import axiosClient from "./axiosClient";

export const getReservations = async (storeUuid, channelUuid, startDate, endDate) => {
    try {
        const response = await axiosClient.get(
            `/stores/${storeUuid}/channels/${channelUuid}/reservations`,
            { params: { start_date: startDate, end_date: endDate } }
        );
        return response.data.data;
    } catch (error) {
        throw error;
    }
};


export const createReservation = async (storeUuid, channelUuid, data) => {
    try {
        const response = await axiosClient.post(
            `/stores/${storeUuid}/channels/${channelUuid}/reservations`,
            data
        );
        return response.data.data;
    } catch (error) {
        throw error;
    }
};
